import type { Pt, ScaleLine } from "@klantpunt/shared";

export type Point = [number, number];
export type DrawMode = "poly" | "rect";

/** Intekenen van één ruimte, of batch ("Ruimtes intekenen": vak → naam → volgende). */
export interface DrawShape {
  kind: "draw";
  mode: DrawMode;
  pts: Point[];
  rect: [number, number, number, number] | null;
  hover: Point | null;
  batch: boolean;
  roomId: string | null;
  roomName: string;
  /** Batch: vlak is klaar, naam wordt gevraagd. */
  naming: boolean;
  shape: Point[] | null;
  nameDraft: string;
  count: number;
  lastName: string;
}

/** Hoekpunten van een bestaand vlak verslepen. */
export interface EditVertices {
  kind: "vertices";
  roomId: string;
  roomName: string;
  points: Point[];
  active: number | null;
}

/** Schaal instellen: twee punten van een bekende maat aantikken en de echte lengte invullen (max. twee maten). */
export interface SetScale {
  kind: "scale";
  floorId: string;
  /** Afgeronde maten. */
  lines: ScaleLine[];
  /** Punten van de maat die nu wordt uitgezet (0–2). */
  pts: Point[];
  /** Ingevulde lengte in meter (tekst, komma toegestaan). */
  meters: string;
}

export type DrawState = DrawShape | EditVertices | SetScale;

export const newDraw = (room: { id: string; name: string }): DrawShape => ({
  kind: "draw",
  mode: "poly",
  pts: [],
  rect: null,
  hover: null,
  batch: false,
  roomId: room.id,
  roomName: room.name,
  naming: false,
  shape: null,
  nameDraft: "",
  count: 0,
  lastName: "",
});

export const newBatch = (mode: DrawMode = "poly"): DrawShape => ({
  ...newDraw({ id: "", name: "" }),
  roomId: null,
  batch: true,
  mode,
});

export const r4 = (v: number) => Math.round(v * 10000) / 10000;
export const toPoints = (p: readonly Pt[]): Point[] => p.map(([x, y]) => [x, y]);

export const newScale = (floorId: string, lines: ScaleLine[] = []): SetScale => ({
  kind: "scale",
  floorId,
  lines,
  pts: [],
  meters: "",
});
